module.exports = __webpack_public_path__ + "static/media/kalkuli.51e7c37f.jpg";